/** *
 * Transforms the cssVars (imported from @schoolinks/ui-components) into camelCase. For eg: fontWeight.halisBlack will be fontWeightHalisBlack, breakpoint.desktopMin will be breakpointDesktopMin
 * color variables can be used without the color prefix. For e.g: color.black will be black, color.greenExtraLight will be greenExtraLight
 *
 * @usage
 * 1. import v from 'components/variables';
 * 2. <Component style={{ background: v.camelCasePropertyName }} />
 *
 * Any changes in the css variables should only be made in utils -> variables.ts file inside ui-components repo. (Check how to link ui-components with sl-fe for local development: https://github.com/SchooLinks/sl-ui-components?tab=readme-ov-file#how-to-link-for-local-development)
 */

import { cssVars } from '@schoolinks/ui-components';
import { camelCase } from 'lodash';

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function removeColorPrefix(variableName) {
  if (variableName.startsWith('color')) {
    const strippedName = variableName.slice(5); // Remove "color" prefix
    return strippedName.charAt(0).toLowerCase() + strippedName.slice(1);
  }
  return variableName; // Return the original name if no prefix
}

function flattenObject(obj, prefix = '', inputResult = {}) {
  const result = { ...inputResult }; // Create a copy of the input result

  Object.keys(obj).forEach(key => {
    const newKey = prefix ? `${prefix}${capitalize(key)}` : key;

    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      Object.assign(result, flattenObject(obj[key], newKey, result));
    } else {
      const transformedKey = camelCase(removeColorPrefix(newKey));
      result[transformedKey] = obj[key];
    }
  });

  return result;
}

export default flattenObject(cssVars);
